import React, { Component } from 'react'
import Select from '../select/Select'

class CirkwiFilters extends Component {

  constructor(props) {
    super(props)
    this.searchParams = new URLSearchParams(window.location.search)

    this.state = {
      destination: null,
      department: null,
      thematic: null,
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.getCrtFiltersParams()
  }

  onChange(name, value) {
    const state = {}
    state[name] = value ? value : null
    this.setState(state)
  }

  onSubmit() {
    this.setFiltersQueryString()

    window.location.search = this.searchParams.toString()
    // history.pushState(null, '', `${window.location.pathname}?${this.searchParams.toString()}`)
  }

  setFiltersQueryString() {
    this.setCrtFiltersParams()

    if (this.state.destination || this.state.department || this.state.thematic) {
      let mbTags = this.props.extra ? this.props.extra : []
      if (this.state.destination) {
        mbTags = mbTags.concat(this.state.destination.value.split(';'))
      }
      if (this.state.department) {
        mbTags = mbTags.concat(this.state.department.value.split(';'))
      }
      if (mbTags.length) {
        this.searchParams.set('mb_tags', mbTags.join(';'))
        this.searchParams.set('mb_tags_all', (mbTags.length > 1) ? 'true' : 'false')
      } else {
        this.deleteSearchParams(['mb_tags', 'mb_tags_all'])
      }

      let mbCategoryPoi = ''
      if (this.state.thematic) {
        mbCategoryPoi = this.state.thematic.value
      }
      if (mbCategoryPoi) {
        this.searchParams.set('mb_categorie_poi', mbCategoryPoi)
        this.searchParams.set('mb_type', 'poi')
      } else {
        this.deleteSearchParams(['mb_type', 'mb_categorie_poi'])
      }

      if (! this.searchParams.has('mb_page')) {
        this.searchParams.set('mb_page', 'recherche')
      }
    } else {
      this.deleteSearchParams(['mb_page', 'mb_tags', 'mb_tags_all', 'mb_type', 'mb_categorie_poi'])
    }
  }

  deleteSearchParams(params) {
    params.forEach((field) => {
      if (this.searchParams.has(field)) {
        this.searchParams.delete(field)
      }
    })
  }

  getCrtFiltersParams() {
    let scrolled = false
    for (let type in this.state) {
      if (this.state.hasOwnProperty(type)) {
        if (this.searchParams.has(`crt_filter_${type}`)) {
          const state = {}
          state[type] = this.setSelectValue(`${type}s`, this.searchParams.get(`crt_filter_${type}`))
          this.setState(state)
          if (! scrolled) {
            document.getElementById('cirkwi-component').scrollIntoView()
            scrolled = true
          }
        }
      }
    }
  }

  setCrtFiltersParams() {
    for (let type in this.state) {
      if (this.state.hasOwnProperty(type)) {
        if (this.state[type] && this.state[type].value) {
          this.searchParams.set(`crt_filter_${type}`, this.state[type].value)
        } else {
          if (this.searchParams.has(`crt_filter_${type}`)) {
            this.searchParams.delete(`crt_filter_${type}`)
          }
        }
      }
    }
  }

  setSelectValue(type, value) {
    if (value) {
      for (let i = 0 ; i < this.props[type].length ; i++) {
        if (this.props[type][i]['value'] === value) {
          return this.props[type][i]
        }
      }
    }

    return null
  }

  render() {
    return (
      <div className="cirkwi-filters">
        <div className="filter-bar">
          <div className="wrap-filter-bar">
            <ul className="selects">
              <li>
                <div className="select">
                  <div className="select-style">
                    <Select
                      type="cirkwi"
                      name="destination"
                      value={this.state.destination}
                      placeholder="Destinations"
                      options={this.props.destinations}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="select">
                  <div className="select-style">
                    <Select
                      type="cirkwi"
                      name="department"
                      value={this.state.department}
                      placeholder="Départements"
                      options={this.props.departments}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="select">
                  <div className="select-style">
                    <Select
                      type="cirkwi"
                      name="thematic"
                      value={this.state.thematic}
                      placeholder="Thématiques"
                      options={this.props.thematics}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              </li>
              <li>
                <button type="button" onClick={this.onSubmit}>Filtrer</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

}

export default (CirkwiFilters)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/cirkwi/CirkwiFilters.js